import AxiosConfig from '@/config/axios-config'

export const BrindesApi = {
  listar (pagina, filtro) {
    return AxiosConfig.secureJalekoAPI().get('/admin/brindes',
      {
        params: {
          page: pagina,
          termo: filtro.termo,
          status: filtro.status,
          recompensa_id: filtro.recompensa_id,
          disponibilizado_em_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
          disponibilizado_em_fim: filtro.createdDate ? filtro.createdDateRange.endDate : '',
          data_envio_inicio: filtro.validDate ? filtro.validDateRange.startDate : '',
          data_envio_fim: filtro.validDate ? filtro.validDateRange.endDate : ''
        }
      }).then(response => response.data)
  },

  listarRecompensas (pagina, filtro) {
    return AxiosConfig.secureJalekoAPI().get('/admin/brindes/recompensas').then(response => response.data)
  },

  atualizarDataEnvio (brinde) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/brindes/dataEnvio/${brinde.id}`, brinde).then(response => response.data)
  },

  exportar (brinde) {
    return AxiosConfig.secureJalekoAPI().post('/admin/brindes/exportar', brinde).then(response => response.data)
  },

  atualizarDataEnvioLote (brinde) {
    return AxiosConfig.secureJalekoAPI().put('/admin/brindes/dataEnvio/', brinde).then(response => response.data)
  }
}
export default BrindesApi
